import React, { createContext, useContext, useState, useEffect } from "react";

// Create a context for Dark Mode
const DarkModeContext = createContext();

export function DarkModeProvider({ children }) {
    // Initialize dark mode: default to true if no preference in localStorage
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const savedMode = localStorage.getItem("darkMode");
        return savedMode !== null ? savedMode === "true" : true; // Default to true (dark mode)
    });

    // Update localStorage and the DOM class whenever isDarkMode changes
    useEffect(() => {
        if (isDarkMode) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
        localStorage.setItem("darkMode", isDarkMode); // Save the preference
    }, [isDarkMode]);

    return (
        <DarkModeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
            {children}
        </DarkModeContext.Provider>
    );
}

// Custom hook to use Dark Mode
export function useDarkMode() {
    return useContext(DarkModeContext);
}
